import { IPartFinderReelsPage } from 'partFinder/types';

export interface IReelsLoadState {
  areMatchesLoaded: boolean;
  familyParts: number;
  isComplete: boolean;
  isNarrowed: boolean;
  isTruncated: boolean;
  loadedParts: number;
  matchedCount: number;
  percentage: number;
  reelsAvailable: boolean;
  truncatedAt: number;
}

const NOTHING_LOADED: IReelsLoadState = {
  areMatchesLoaded: false,
  familyParts: 0,
  isComplete: false,
  isNarrowed: false,
  isTruncated: false,
  loadedParts: 0,
  matchedCount: 0,
  percentage: 0,
  reelsAvailable: true,
  truncatedAt: 0,
};

// Where loading the family's rows stands, from what the server said with each page: how many of
// its parts are in, whether the parts the search picked are all in, and the grid's progress.
export const getReelsLoadState = (
  pages: IPartFinderReelsPage[],
  hasNextPage = false
): IReelsLoadState => {
  const lastPage = pages[pages.length - 1];

  if (!lastPage) {
    return NOTHING_LOADED;
  }

  const { isTruncated, matchedCount, partsCount, partsEnd: loadedParts, truncatedAt } = lastPage;
  const familyParts = Math.min(partsCount, truncatedAt);
  const isComplete = !hasNextPage;

  return {
    // The picked parts come first, so they are all in once the pages reach past them.
    areMatchesLoaded: loadedParts >= Math.min(matchedCount, familyParts),
    familyParts,
    isComplete,
    // Picks that match every part of the family, or none, leave no part to load first.
    isNarrowed: matchedCount > 0 && matchedCount < partsCount,
    isTruncated,
    loadedParts,
    matchedCount,
    // In parts. 100 only once the last page is in: the grid reads 100 as "every row loaded".
    percentage: isComplete
      ? 100
      : Math.min(99, familyParts ? (loadedParts / familyParts) * 100 : 0),
    reelsAvailable: pages.every((page) => page.reelsAvailable),
    truncatedAt,
  };
};
